import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import PaymentLayout from './components/payment_layout';
import './payment.css';

const PaymentIndex = () => {
    const { running_number } = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const tt = queryParams.get('tt');

    return (
        <>
            <div>
                <PaymentLayout running_number={running_number} tt={tt}/>
            </div>
        </>
    );
}

export default PaymentIndex;